import ErrorStateActions from './constants';
import { IActionObject, IErrorValues } from './types';

// Sets form state for an array of fieldKey, fieldValue
export function setErrorState(data: IErrorValues): IActionObject {
  return { type: ErrorStateActions.SET_ERROR_STATE, data };
}

// Clears form state
export function resetErrorState(): IActionObject {
  return { type: ErrorStateActions.RESET_ERROR_STATE };
}
try {
    // @ts-ignore
    setErrorState.displayName = "setErrorState";
    // @ts-ignore
    setErrorState.__docgenInfo = { "description": "", "displayName": "setErrorState", "props": { "fieldValues": { "defaultValue": null, "description": "", "name": "fieldValues", "required": true, "type": { "name": "IFieldValue[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/error/actions.tsx#setErrorState"] = { docgenInfo: setErrorState.__docgenInfo, name: "setErrorState", path: "src/store/error/actions.tsx#setErrorState" };
}
catch (__react_docgen_typescript_loader_error) { }